"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleRule_1 = require("./_LifecycleRule");
exports._LifecycleRules = {
    type: "list",
    flattened: true,
    member: {
        shape: _LifecycleRule_1._LifecycleRule
    }
};
//# sourceMappingURL=_LifecycleRules.js.map